module.exports = __webpack_public_path__ + "img/MARCONFORT_logo_lg.png";